/*
 *   File : listing.js
 *   Author : https://evoqins.com
 *   Description : Fund list
 *   Version : 1.0.0
*/

import { Fragment, useEffect, useState } from "react"
import { CustomTitle } from "../../Components/Title"
import APIService from "../../Services/api-service";
import { CustomTabBar } from "../../Components/Tab";
import { SecondaryButton, TextButton } from "../../Components/Buttons";
import { UpdateAllocation } from "../../Components/Modal";
import { Modal } from "bootstrap";

const BasketListing = () => {
    const [basketData, setBasketData] = useState([]);
    const [pageLoader, setPageLoader] = useState(true);
    const [basketFilter, setBasketFilter] = useState([]);
    const [selectedBasket, setSelectedBasket] = useState(null);
    const [basketObj, setBasketObj] = useState(null);
    const [addFund, setAddFund] = useState(false);

    useEffect(() => {
        _getBasketFilter();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (addFund === true) {
            const modal = new Modal(document.getElementById("update-allocation"));
            modal.show()
        }
    }, [addFund]);

    // API - get basket list
    const _getBasketFilter = () => {
        const url = "/baskets/basket-list";

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                _getBasketList();
                setBasketFilter(response.data);
                setSelectedBasket(response.data[0].id);
            }
        });
    }

    // API - get fund list
    const _getBasketList = () => {
        const url = "/baskets/list";

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                setBasketData(response.data);
            }
            setPageLoader(false);
        });
    }

    function _handleAddFund(status, data) {
        setAddFund(status);
        setBasketObj(data);
    }
    return (
        <Fragment>
            <div className="e-bg-light-lavender pt-3 padding-52px-lr">
                <CustomTitle title="Manage Baskets" type={1} />
            </div>
            <div className="e-body-wrapper">
                <div className="row">
                    <div className="col-12">
                        <div className="bg-white border-radius-32px padding-40px-tb ">
                            {
                                pageLoader === true ?
                                    <div className="h-80vh d-flex align-items-center justify-content-center">
                                        <img src={require("../../Assets/Images/Loader/page-loader.gif")}
                                            alt={"loader"}
                                            width={60}
                                            height={60}
                                        />
                                    </div>
                                    :
                                    <div className="padding-32px-lr">
                                        <div className="d-flex justify-content-between align-items-center px-3">
                                            <CustomTabBar data={basketFilter}
                                                selectedTab={selectedBasket}
                                                onSelectTab={(tab_index) => setSelectedBasket(tab_index)} />
                                            <div>
                                                <TextButton name="Edit Allocation" hide_arrow={true}
                                                    onPress={() => _handleAddFund(true, basketData[`${selectedBasket}`])} />
                                            </div>
                                        </div>
                                        <div className="e-box-shadow-black36 border-radius-12px p-3 mt-3">
                                            {/* <h6 className="color-dark-charcoal e-font-14 e-montserrat-bold e-line-height-24 mb-0">
                                                            Asset class - <span className="e-montserrat-bold">{item.asset_class} </span>
                                                        </h6> */}
                                            <div className="e-bg-pastel-lavender p-3 border-radius-12px e-box-shadow-black36 mt-2 pb-0">
                                                {
                                                    (basketData[`${selectedBasket}`] ?? []).map((item, key) => {
                                                        return (
                                                            <div className="row pb-3 align-items-center">
                                                                <div className="col-8">
                                                                    <span className="e-font-12 e-line-height-18 color-dark-charcoal e-montserrat-medium">{item.fund_name} <span className="e-montserrat-bold">({item.fund_alias})</span></span>
                                                                </div>
                                                                {/* <div className="col-2">
                                                                    <span className="e-font-14 e-line-height-20 color-dark-charcoal e-montserrat-semi-bold">{item.asset_class}</span>
                                                                </div> */}
                                                                <div className="col-2 text-end">
                                                                    <span className="e-font-14 e-line-height-20 color-dark-charcoal e-montserrat-semi-bold">{item.allocation}%</span>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <SecondaryButton label="Add More Funds" hide_arrow={true}
                                            className="padding-12px-tb px-4 mt-3"
                                            handleClick={() => _handleAddFund(true, null)} />
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {
                addFund === true && <UpdateAllocation data={basketObj}
                    closeModal={() => _handleAddFund(false, null)}
                    basketId={selectedBasket}
                    updateList={_getBasketList} />
            }
        </Fragment>
    )
}

export default BasketListing
